import { NavLink } from "react-router-dom";
import {
  MapPin,
  Heart,
  Bell,
  User,
  Crown,
} from "@phosphor-icons/react";

const items = [
  { to: "/map", label: "Mapa", icon: MapPin, testId: "nav-map" },
  { to: "/meetings", label: "Encuentros", icon: Heart, testId: "nav-meetings" },
  { to: "/notifications", label: "Avisos", icon: Bell, testId: "nav-notifications" },
  { to: "/account", label: "Cuenta", icon: User, testId: "nav-account" },
  { to: "/subscription", label: "Plan", icon: Crown, testId: "nav-subscription" },
];

export default function BottomNav() {
  return (
    <nav
      className="zx-bottomnav"
      role="navigation"
      aria-label="Bottom navigation"
      data-testid="bottom-nav"
    >
      <ul className="mx-auto flex max-w-xl items-stretch justify-between px-2 py-2">
        {items.map((it) => {
          const Icon = it.icon;
          return (
            <li key={it.to} className="flex-1">
              <NavLink
                to={it.to}
                data-testid={it.testId}
                className={({ isActive }) =>
                  [
                    "group flex flex-col items-center gap-1 py-2 px-1 rounded-lg transition-all",
                    isActive
                      ? "text-[#f5f5f5]"
                      : "text-[rgba(255,255,255,0.55)] hover:text-[#f5f5f5]",
                  ].join(" ")
                }
                end
              >
                {({ isActive }) => (
                  <>
                    <span
                      className={[
                        "flex h-8 w-8 items-center justify-center rounded-full transition-all",
                        isActive
                          ? "bg-[rgba(139,30,63,0.18)] ring-1 ring-[rgba(184,50,90,0.45)]"
                          : "ring-1 ring-transparent group-hover:bg-[rgba(255,255,255,0.04)]",
                      ].join(" ")}
                    >
                      <Icon
                        size={20}
                        weight={isActive ? "fill" : "thin"}
                        color={isActive ? "#B8325A" : "currentColor"}
                      />
                    </span>
                    <span
                      className="text-[10px] tracking-[0.2em] uppercase"
                      style={{ fontFamily: "Space Mono, monospace" }}
                    >
                      {it.label}
                    </span>
                  </>
                )}
              </NavLink>
            </li>
          );
        })}
      </ul>
    </nav>
  );
}
